import { render, staticRenderFns } from "./StudyReportForm.vue?vue&type=template&id=ec9c1c44&scoped=true&"
import script from "./StudyReportForm.vue?vue&type=script&lang=ts&"
export * from "./StudyReportForm.vue?vue&type=script&lang=ts&"
import style0 from "./StudyReportForm.vue?vue&type=style&index=0&id=ec9c1c44&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.10.1_cache-loader@4.1.0_css-loader@3.6.0_vue-template-compiler@2.7.14_webpack@4.46.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec9c1c44",
  null
  
)

export default component.exports